import { render, staticRenderFns } from "./Backhaul.vue?vue&type=template&id=544a8654"
import script from "./Backhaul.vue?vue&type=script&lang=js"
export * from "./Backhaul.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports